<div [formGroup]="formGroup">
    <div formGroupName="{{formGroupName}}">
        <div class="flex gap-20" ngClass.xs="flex-column gap-0">
            <mat-form-field>
                <mat-label>Shipping Company</mat-label>
                <input matInput formControlName="shipping_company" maxlength="255">
            </mat-form-field>
            <div>
              <mat-form-field>
                    <mat-label>Shipment Date</mat-label>
                    <input matInput [matDatepicker]="picker" readonly (click)="picker.open()" formControlName="shipping_date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker  [touchUi]="deviceService.isMobile() || deviceService.isTablet()" #picker></mat-datepicker>
                    <mat-error>A valid date is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="flex gap-20" ngClass.xs="flex-column gap-0">
            <div>
                <mat-form-field>
                    <mat-label>Expected Date</mat-label>
                    <input matInput [matDatepicker]="edpicker" readonly (click)="edpicker.open()" formControlName="expected_date">
                    <mat-datepicker  [touchUi]="deviceService.isMobile() || deviceService.isTablet()" #edpicker></mat-datepicker>
                    <mat-error>A valid date is required</mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-label>Actual Date</mat-label>
                    <input matInput [matDatepicker]="adpicker" readonly (click)="adpicker.open()" formControlName="actual_date">
                    <mat-datepicker  [touchUi]="deviceService.isMobile() || deviceService.isTablet()" #adpicker></mat-datepicker>
                    <mat-error>A valid date is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="flex" ngClass.xs="flex-column">
            <mat-form-field class="full-line" ngClass.xs="mobile-full-line">
                <mat-label>Tracking Number</mat-label>
                <input matInput formControlName="tracking_number" maxlength="255">
            </mat-form-field>
        </div>
        <div class="flex gap-20" ngClass.xs="flex-column gap-0">
            <mat-form-field style="flex: 1">
                <mat-label>Receiver Name</mat-label>
                <input matInput formControlName="receiver_name" maxlength="255">
            </mat-form-field>
            <mat-form-field style="flex: 1">
                <mat-label>Receiver Phone</mat-label>
                <input matInput formControlName="receiver_phone" maxlength="255">
            </mat-form-field>
        </div>
    </div>
</div>
